import { ChatRoom, ChatRoomType } from '@dinosband/bv-main-schema/dist/types'

import { DataCenter_StoreType } from '../abstract'
import { CHAT_ROOM_ADDED } from './const'

export class CommentsChatRooms extends DataCenter_StoreType<number, ChatRoom> {

  // private _subscriber?: CommentsChatRoomSubscriber

  async init () {
    // this._subscriber = new CommentsChatRoomSubscriber(this.context.mainStore, (value) => this.onChatRoomAdded(value))
    // await this._subscriber.start()
  }

  // cleanup () {
  //   super.cleanup()
  //   this._subscriber?.cleanup()
  //   this._subscriber = _undefined()
  // }

  get chatRooms () {
    return this.values
  }

  // onReconnected () {
  //   this._subscriber?.retrieve()
  // }

  async findChatRoom (arg: { chatRoomId?: number, rootMessageId?: number}) {
    let found: ChatRoom | undefined
    if (arg.chatRoomId) {
      found = this.chatRooms[arg.chatRoomId]
    } else if (arg.rootMessageId) {
      found = this.chatRooms.find((i) => i.commentsRootMessageId === arg.rootMessageId)
    }
    if (found) {
      return found
    }
    const chatRoom = await this.mainStore.readCommentsChatRoom(arg.chatRoomId, arg.rootMessageId)
    if (chatRoom) {
      this.onChatRoomAdded(chatRoom)
    }
    return chatRoom
  }

  async requestCommentsChatRoom (rootMessageId: number, commentsRootChatRoomId: number, channelId: number) {
    const selected = await this.findChatRoom({ rootMessageId })
    if (selected) {
      return selected
    }
    const chatRoom = await this.mainStore.createCommentsChatRoom(rootMessageId, commentsRootChatRoomId, channelId)
    if (chatRoom) {
      this.onChatRoomAdded(chatRoom)
    }
    return chatRoom
  }

  private onChatRoomAdded (value: ChatRoom) {
    this.set(value.id, value)
    this.pubsub.publish(CHAT_ROOM_ADDED, {
      type: ChatRoomType.COMMENTS,
      channelId: value.channelId,
      chatRooms: [value] })
  }

}
